import type { RouteObject } from "react-router-dom";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Accueil from "../pages/accueil/page";
import Inscription from "../pages/inscription/page";
import Connexion from "../pages/connexion/page";
import TableauDeBord from "../pages/tableau-de-bord/page";
import PaiementActivation from "../pages/paiement-activation/page";
import AdminPage from "../pages/admin/page";
import MotDePasseOublie from "../pages/mot-de-passe-oublie/page";

// ✅ Ces numéros fixes sont autorisés à accéder à l'administration
const SUPER_ADMINS = ['97800237', '92242664', '92252664', '98436291', '90804284'];

function isAdminAuthorized(): boolean {
  // Vérifier via sessionStorage (déjà connecté en admin)
  const adminPhone = sessionStorage.getItem('adminPhone');
  const adminPassword = sessionStorage.getItem('adminPassword');
  if (adminPhone && adminPassword) {
    const ADMIN_PASSWORDS: Record<string, string> = {
      '97800237': '123640',
      '92242664': '123640',
      '92252664': 'eriCA@31',
      '98436291': 'eriCA@31',
      '90804284': 'Achraf90',
    };
    if (adminPhone in ADMIN_PASSWORDS && ADMIN_PASSWORDS[adminPhone] === adminPassword) return true;
  }
  // Vérifier via userPhone (utilisateur connecté qui est admin)
  const userPhone = localStorage.getItem('userPhone');
  if (userPhone && SUPER_ADMINS.includes(userPhone)) return true;
  
  return false;
}

// Composant de protection de la route admin
function AdminGuard() {
  const navigate = useNavigate();
  const authorized = isAdminAuthorized();

  useEffect(() => {
    if (!authorized) {
      navigate('/connexion', { replace: true });
    }
  }, [authorized, navigate]);

  if (!authorized) return null;
  return <AdminPage />;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Accueil />,
  },
  {
    path: "/inscription",
    element: <Inscription />,
  },
  {
    path: "/connexion",
    element: <Connexion />,
  },
  {
    path: "/mot-de-passe-oublie",
    element: <MotDePasseOublie />,
  },
  {
    path: "/paiement-activation",
    element: <PaiementActivation />,
  },
  {
    path: "/tableau-de-bord",
    element: <TableauDeBord />,
  },
  {
    path: "/admin",
    element: <AdminGuard />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;